/* heimatkinner – Warenkorb-Schublade, Größentabelle, kleine Helfer (auf allen Seiten) */
(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
  const money = cents => (cents / 100).toLocaleString("de-DE", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" });

  const drawer = qs("[data-hk-drawer]"), scrim = qs("[data-hk-scrim]"), toastEl = qs("[data-hk-toast]");
  let toastTimer, lastVariant = null;

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove("show"), 2800);
  }

  function open() {
    if (!drawer) { location.href = root + "cart"; return; }
    drawer.classList.add("show"); scrim.classList.add("show"); drawer.setAttribute("aria-hidden", "false");
    const c = qs("[data-hk-cart-close]", drawer); if (c) c.focus();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove("show"); scrim.classList.remove("show"); drawer.setAttribute("aria-hidden", "true");
  }

  function esc(s) { return String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])); }

  function render(cart) {
    qsa("[data-hk-cart-count]").forEach(el => el.textContent = cart.item_count);
    if (!drawer) return;
    const lines = qs("[data-hk-lines]", drawer), sub = qs("[data-hk-subtotal]", drawer), up = qs("[data-hk-upsell]", drawer), checkout = qs("[data-hk-checkout]", drawer);
    sub.textContent = money(cart.total_price);
    if (!cart.items.length) {
      lines.innerHTML = '<p class="empty">Dein Warenkorb ist leer.</p>';
      if (up) up.hidden = true;
      checkout.setAttribute("aria-disabled", "true"); checkout.style.pointerEvents = "none"; checkout.style.opacity = ".4";
      return;
    }
    checkout.removeAttribute("aria-disabled"); checkout.style.pointerEvents = ""; checkout.style.opacity = "";
    lastVariant = cart.items[cart.items.length - 1].variant_id;
    if (up) up.hidden = false;
    lines.innerHTML = cart.items.map(it => {
      const opt = (it.options_with_values || []).find(o => /gr|size/i.test(o.name));
      const size = opt ? `Größe ${esc(opt.value)} · ` : it.variant_title && it.variant_title !== "Default Title" ? `${esc(it.variant_title)} · ` : "";
      const img = it.image ? `<img src="${esc(it.image)}" alt="" loading="lazy">` : "";
      return `<div class="line">${img}<div><b>${esc(it.product_title)}</b><span>${size}${it.quantity} Stück</span><button class="linkbtn rm" type="button" data-hk-remove="${esc(it.key)}">Entfernen</button></div><span class="p">${money(it.final_line_price)}</span></div>`;
    }).join("");
  }

  async function refresh() {
    const r = await fetch(root + "cart.js", { headers: { Accept: "application/json" } });
    const cart = await r.json(); render(cart); return cart;
  }

  async function add(variantId, quantity = 1) {
    const r = await fetch(root + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!r.ok) {
      let msg = "Das hat nicht geklappt. Bitte versuch es noch einmal.";
      try { const e = await r.json(); if (e.description) msg = e.description; } catch (_) {}
      toast(msg); throw new Error(msg);
    }
    await refresh(); open();
  }

  async function remove(key) {
    await fetch(root + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await refresh();
  }

  document.addEventListener("click", e => {
    const t = e.target.closest("[data-hk-cart-open], [data-hk-cart-close], [data-hk-scrim], [data-hk-remove], [data-hk-upsell-add], [data-open-size], [data-hk-close-size], [data-hk-scroll-to]");
    if (!t) return;
    if (t.matches("[data-hk-cart-open]")) { if (drawer) { e.preventDefault(); refresh().then(open); } }
    else if (t.matches("[data-hk-cart-close], [data-hk-scrim]")) close();
    else if (t.matches("[data-hk-remove]")) remove(t.dataset.hkRemove);
    else if (t.matches("[data-hk-upsell-add]")) { if (lastVariant) add(lastVariant, 1); }
    else if (t.matches("[data-open-size]")) { e.preventDefault(); openSize(); }
    else if (t.matches("[data-hk-close-size]")) { const d = qs("[data-hk-size-dialog]"); if (d) d.close(); }
    else if (t.matches("[data-hk-scroll-to]")) {
      const target = document.getElementById(t.dataset.hkScrollTo); if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      const input = qs("input[type=email]", target); if (input) setTimeout(() => input.focus({ preventScroll: true }), 500);
    }
  });
  addEventListener("keydown", e => { if (e.key === "Escape") close(); });

  // Größentabelle: markiert die gerade gewählte Größe
  function openSize() {
    const d = qs("[data-hk-size-dialog]"); if (!d) return;
    // Bei Shirt/Hoodie: Tabelle des gerade gewählten Artikels zeigen
    const g = qsa("[data-hk-group]").find(x => !x.hidden);
    const sets = qsa("[data-hk-sizeset]", d);
    const set = sets.find(x => g && x.dataset.hkSizeset === g.dataset.tag) || sets[0];
    sets.forEach(x => { x.hidden = x !== set; });
    const checked = qs("[data-hk-size-input]:checked", g || document);
    const size = checked ? checked.dataset.size : null;
    qsa("tbody tr", set || d).forEach(tr => tr.classList.toggle("on", tr.dataset.size === size));
    try { d.showModal(); } catch (_) { d.setAttribute("open", ""); }
  }
  document.addEventListener("click", e => { const d = e.target.closest("[data-hk-size-dialog]"); if (d && e.target === d) d.close(); });

  window.hkCart = { add, refresh, open, close, toast, money };
})();
